import { connect } from 'react-redux'

import { doRenderTicketListBeforeSearch } from 'actions/app'
import { doFetchTopLabels, doSearchLabels } from 'actions/labels'
import {
  doUpdateTicketSearchQuery,
  doToggleListSearchBoxFocused,
  doSubmitTicketsSearch,
} from 'actions/search'
import {
  selectCurrentFolderContext,
  selectTicketListBeforeSearch,
} from 'selectors/app'
import { selectLabelsByMailboxId } from 'selectors/labels'
import { selectLabelSearchResultsByTerm } from 'selectors/labelings'
import {
  selectCurrentCommittedTicketSearchQueryString,
  selectDisplayedSearchQueryString,
} from 'selectors/search/base'
import { selectTicketSearchSuggestions } from 'selectors/search_suggestions'
import { selectIsFreeFormSearch, selectIsTypedSearch } from 'selectors/search'
import { selectCustomersByEmail } from 'ducks/customers/selectors'
import { doSearchRecipients } from 'ducks/drafts'

import SearchView from 'components/ConversationList/Header/Search'
import { selectCurrentSubmittedTicketSearchFilterMatches } from 'selectors/search/searchFilters'

const select = state => {
  return {
    committedSearchQuery: selectCurrentCommittedTicketSearchQueryString(state),
    folderContext: selectCurrentFolderContext(state),
    isFreeFormSearch: selectIsFreeFormSearch(state),
    labelsByTerm: selectLabelSearchResultsByTerm(state),
    searchQuery: selectDisplayedSearchQueryString(state),
    customersByEmail: selectCustomersByEmail(state),
    suggestions: selectTicketSearchSuggestions(state),
    conversationListBeforeSearch: selectTicketListBeforeSearch(state),
    topLabels: selectLabelsByMailboxId(state).null,
    isTypedSearch: selectIsTypedSearch(state),
    currentSubmittedTicketSearchFilterMatches: selectCurrentSubmittedTicketSearchFilterMatches(
      state
    ),
  }
}

const perform = {
  doFetchTopLabels,
  doSearchLabels,
  doToggleListSearchBoxFocused,
  doUpdateTicketSearchQuery,
  doSearchRecipients,
  onClearClick: doRenderTicketListBeforeSearch,
  doSubmitTicketsSearch,
}

export default connect(select, perform)(SearchView)
